import { render, staticRenderFns } from "./CommissionReportItemsTable.vue?vue&type=template&id=01b6b9ba"
import script from "./CommissionReportItemsTable.vue?vue&type=script&lang=js"
export * from "./CommissionReportItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports